import { createReducer, on } from '@ngrx/store';
import { ClauseLibraryActions } from './actions';
import { initialState } from './state';

export const featureReducer = createReducer(
  initialState,
  on(ClauseLibraryActions.setClauses, (state, { clauses }) => ({
    ...state,
    clauses: clauses,
    loadingClauses: false,
  })),
  on(ClauseLibraryActions.loadClauses, (state, {}) => ({
    ...state,
    loadingClauses: true,
  })),
  on(ClauseLibraryActions.loadClausesFail, (state, {}) => ({
    ...state,
    loadingClauses: false,
  })),
  on(ClauseLibraryActions.createClause, (state, {}) => ({
    ...state,
    creatingClause: true,
    closeCreatingClauseModal: false,
  })),
  on(ClauseLibraryActions.createClauseCancel, (state, {}) => ({
    ...state,
    creatingClause: false,
    closeCreatingClauseModal: false,
  })),
  on(ClauseLibraryActions.createClauseSuccess, (state, {}) => ({
    ...state,
    creatingClause: false,
    closeCreatingClauseModal: false,
  })),
  on(ClauseLibraryActions.createClauseFail, (state, {}) => ({
    ...state,
    creatingClause: false,
    closeCreatingClauseModal: false,
  })),
  on(ClauseLibraryActions.createClauseCancelled, (state, {}) => ({
    ...state,
    closeCreatingClauseModal: true,
  })),
  on(ClauseLibraryActions.closeCreatingClauseModal, (state, {}) => ({
    ...state,
    closeCreatingClauseModal: true,
  })),
  on(ClauseLibraryActions.clearCreateClauseCancelled, (state, {}) => ({
    ...state,
    closeCreatingClauseModal: false,
  })),
  on(ClauseLibraryActions.deleteClause, (state, {}) => ({
    ...state,
    deletingClause: true,
  })),
  on(ClauseLibraryActions.deleteClauseCancel, (state, {}) => ({
    ...state,
    deletingClause: false,
  })),
  on(ClauseLibraryActions.deleteClauseSuccess, (state, {}) => ({
    ...state,
    deletingClause: false,
  })),
  on(ClauseLibraryActions.deleteClauseFail, (state, {}) => ({
    ...state,
    deletingClause: false,
  })),
  on(ClauseLibraryActions.setClause, (state, { clause }) => ({
    ...state,
    clause: clause,
    loadingClause: false,
  })),
  on(ClauseLibraryActions.loadClause, (state, {}) => ({
    ...state,
    loadingClause: true,
  })),
  on(ClauseLibraryActions.loadClauseFail, (state, {}) => ({
    ...state,
    loadingClause: false,
  })),
  on(ClauseLibraryActions.editClause, (state, {}) => ({
    ...state,
    editingClause: true,
    closeEditingClauseModal: false,
  })),
  on(ClauseLibraryActions.editClauseCancel, (state, {}) => ({
    ...state,
    editingClause: false,
    closeEditingClauseModal: false,
  })),
  on(ClauseLibraryActions.editClauseSuccess, (state, {}) => ({
    ...state,
    editingClause: false,
    closeEditingClauseModal: false,
  })),
  on(ClauseLibraryActions.editClauseFail, (state, {}) => ({
    ...state,
    editingClause: false,
    closeEditingClauseModal: false,
  })),
  on(ClauseLibraryActions.editClauseCancelled, (state, {}) => ({
    ...state,
    clause: null,
    closeEditingClauseModal: true,
  })),
  on(ClauseLibraryActions.closeEditingClauseModal, (state, {}) => ({
    ...state,
    clause: null,
    closeEditingClauseModal: true,
  })),
  on(ClauseLibraryActions.clearEditClauseCancelled, (state, {}) => ({
    ...state,
    closeEditingClauseModal: false,
  })),
);
